export default function Button({ children, onClick, variant = 'primary', size = 'md', disabled, className = '', icon }) {
  const base = 'inline-flex items-center justify-center gap-2 font-medium rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed'

  const variants = {
    primary: 'text-white hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'bg-subtle text-heading border border-card hover:bg-active',
    ghost: 'text-muted hover:text-heading bg-hover',
    danger: 'bg-negative-soft text-negative border border-negative-soft hover:opacity-80',
  }

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
  }

  const primaryStyle = variant === 'primary'
    ? { background: 'linear-gradient(135deg, var(--primary), var(--secondary))' }
    : {}

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={primaryStyle}
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {icon && <span className="w-4 h-4">{icon}</span>}
      {children}
    </button>
  )
}
